import React from 'react';
import { Badge } from 'react-bootstrap';

// How a Payment's money and status read on every payment table and card
// (Order Details' payment history, the Order Ledger, the payment details and
// refund modals, the Payments page). These were five private copies.

// HUF: rounded + " Ft"; EUR: "€" + 2 decimals; anything else: the code in
// front. A payment with no currency is EUR, as everywhere else here.
export function formatPaymentAmount(amount, currency) {
  if (amount == null || Number.isNaN(Number(amount))) return '—';
  const n = Number(amount);
  if (currency === 'HUF') return `${Math.round(n).toLocaleString('en-US')} Ft`;
  const cur = currency || 'EUR';
  const symbol = cur === 'EUR' ? '€' : `${cur} `;
  return `${symbol}${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Green for completed, warning for in-flight, danger for refunded so a
// refunded original stands out from the successful rows beside it.
const PAYMENT_STATUS_VARIANTS = {
  completed: { bg: 'success', label: 'Completed' },
  pending: { bg: 'warning', label: 'Pending' },
  failed: { bg: 'secondary', label: 'Failed' },
  refunded: { bg: 'danger', label: 'Refunded' },
  reconciled: { bg: 'info', label: 'Reconciled' },
};

export function PaymentStatusBadge({ status }) {
  if (!status) return <span className="text-muted">—</span>;
  const variant = PAYMENT_STATUS_VARIANTS[status] || { bg: 'secondary', label: status };
  return <Badge bg={variant.bg}>{variant.label}</Badge>;
}
